<template>
    <div> 
        <div class="row"> 
            <div class="col-xs-12" style="margin-top:20px;">
                <p>
                  <a class="linkGenerico link-breadcrumbs" :href="schedaAppData.linkCategoriaNavigateUrl">{{ schedaAppData.prodottoInfo.CategoriaLivello1 }}</a>
                  &nbsp;/&nbsp;                   
                  <a class="linkGenerico link-breadcrumbs" :href="schedaAppData.linkSottoCategoriaNavigateUrl">{{ schedaAppData.prodottoInfo.CategoriaLivello2 }}</a>
                  &nbsp;/&nbsp;
                  <a class="linkGenerico link-breadcrumbs" :href="schedaAppData.linkSottoCategoria2LivelloNavigateUrl">{{ schedaAppData.prodottoInfo.CategoriaLivello3 }}</a>
                  &nbsp;/&nbsp;
                  {{ schedaAppData.prodottoInfo.Descrizione }}
                </p>
            </div>
        </div>
        <div class="row flex-container">
          <div class="col-xs-12 col-md-4" style="text-align:center;">
              <!--IMG PRODOTTO -->
              <img :src="currentVarColoreImageUrl" :alt="currentVarColoreAltText" class="img-responsive" style="display:inline-block;cursor:pointer;"
                    @click="showPopupImageZoom(currentVarColoreZoomImageUrl)" />
          </div>    
          <div class="col-xs-12 col-md-8 flex-container">
            <!--DESCRIZIONI A FIANCO -->
            <div class="row flex-container-column" style="flex:1;">
              <div class="col-xs-12">
                <!--CODICE PRODOTTO -->
                <h2>  
                  <span style="font-size:16.5px; font-weight:bold;">{{schedaAppData.prodottoInfo.Descrizione}}</span>
                </h2>
                <h5><span style="font-size:16.5px;">Cod. {{schedaAppData.prodottoInfo.CodiceListino}}{{(brand !== '' ? ` | ${this.schedaAppData.prodottoInfo.MarchioInvariante}` : '' )}}</span></h5>
                <!--DESCRIZIONE LUNGA PRODOTTO, SOLO 1 RIGA -->
                <h2 class="descrizione-estesa" style="margin-bottom:0;" v-html="this.schedaAppData.prodottoInfo.DesCata.replaceAll('\r', '<br />').replace('<br />', '')"></h2>                  
              </div>
              <div class="col-xs-12 flex-container-column" style="flex:1; justify-content: center;"> 
                <div class="flex-container-column" style="flex:1; justify-content: space-evenly;">
                  <div class="fastLinkInfo">
                    <a class="nav-link" style="font-size: 16.5px;" onclick="$('#dati-aggiuntivi-desc-lunga')[0].scrollIntoView({ behavior: 'smooth' });">+ caratteristiche</a>
                  </div>
                  <div :style="(this.userInfo ? 'visibility:hidden;':'') "
                        style="color:white;background-color:#00AEEF;padding:10px;font-weight:bold;text-align:center;justify-content:center;">
                      LOGGATI E VEDRAI I PREZZI CHE TI ABBIAMO RISERVATO
                  </div>
                </div>
              </div>
              <div class="col-xs-12 flex-container-column" style="margin-bottom:5px;">
                <b>{{this.userInfo ? 'Schema prezzi riservati | prezzi cad. + IVA' : 'Schema prezzi al pubblico consigliati | prezzi cad. + IVA'}}</b>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12 col-md-4" style="text-align:center;">
            <p style="padding-top:5px;">{{currentVarColoreDescColore}}</p>
          </div>
          <div class="col-xs-12 col-md-8"> <!-- flex-container-column -->
            <!-- Schema prezzi per il prodotto base -->
            <div class="loader-centered" v-if="loadingPrezzi">
              <pulse-loader :loading="loadingPrezzi" :color="colorSpinner">
              </pulse-loader>
            </div>
            <div v-if="prezziData !== null" style="overflow-x:auto;">
              <table class="tablePrezzi" style="width:100%;">
                <tbody>
                  <tr>
                    <td>{{this.prezziData.LabelDescQuantita}}</td>
                    <td v-for="qta in this.prezziData.ListaQuantita" :key="qta.key">
                      <b>{{`+ ${qta}`}}</b>
                    </td>
                  </tr>
                  <tr v-if="!schedaAppData.prodottoInfo.SeCategoriaFullCustom && !schedaAppData.prodottoInfo.SeArtSoloPersonalizzabile">
                    <td :style="this.prezziData.ArticoloOutlet ? 'color:red;' : ''">{{`${this.prezziData.LabelDescPrezzi} articolo neutro`}}</td>
                    <td v-for="prezzo in this.prezziData.ListaPrezzi" :key="prezzo.key" :style="this.prezziData.ArticoloOutlet ? 'color:red;' : ''">
                      <span :style="!this.userInfo ? 'text-decoration:line-through' : ''">
                        {{prezzoToString(prezzo)}}
                      </span>
                    </td>
                  </tr>
                  <tr v-if="this.prezziData.ListaPrezziConPers.length > 0 && this.prezziData.ListaPrezziConPers.some(x => x > 0)">
                    <td>{{this.prezziData.LabelDescPrezziConPers}}*</td>
                    <template v-for="prezzoConPers in this.prezziData.ListaPrezziConPers" :key="prezzoConPers.key">
                      <td v-if="prezzoConPers > 0">
                        <span :style="!this.userInfo ? 'text-decoration:line-through' : ''">
                          {{prezzoToString(prezzoConPers)}}
                        </span>
                      </td>
                      <td v-else></td>
                    </template>
                  </tr>
                </tbody>
              </table>
              <p v-if="this.prezziData.ListaPrezziConPers.length > 0 && this.prezziData.ListaPrezziConPers.some(x => x > 0)" style="font-size: smaller;">
                * Prezzo per la personalizzazione di default. Il prezzo di eventuali altre personalizzazioni è calcolabile al passaggio successivo
              </p>
            </div>
          </div>
        </div>
        
        <div class="row withMarginTop">
          <div class="col-xs-12 col-md-4">
            <!--SEZIONE COLORI -->
            <div><b>Colori</b></div>
            <div v-if="loadingSezioneColori" class="loader-centered" style="margin-top:20px;">
              <pulse-loader :loading="loadingSezioneColori" :color="colorSpinner">
              </pulse-loader>
            </div>
            <div id="carouselGalleriaFotografica" class="flexslider" style="font-size:smaller;">
              <ul class="slides">
                <li v-for="item in listaVariantiColore" :key="item.key">
                  <div v-if="item.imgFileName === undefined" class="loader-centered" style="margin-top:20px;">
                    <clip-loader :loading="item.imgFileName === undefined" :color="colorSpinner">
                    </clip-loader>
                  </div>
                  <!-- :href="item.urlScheda" -->
                  <a @click="loadMainImgVarianteColore(item)" style="cursor: pointer;"
                    data-toggle="popover" data-html="true" data-placement="top" data-container="body" title="" class="popoverVarianti"
                    :data-content="item.popOverText" v-show="item.imgFileName !== undefined">
                    <img style="font-weight:normal;font-size:0.8em;border:1px solid lightgray;" :alt="item.imgAltText" :title="item.imgTitle" :src="item.imgFileName" />
                  </a>
                  <!-- <p style="margin-top:10px; text-align:center;" v-if="item.pzOpzionati > 0">
                    <img src="/portals/0/Images/opzionato_small.png" style="height:auto !important; width:auto !important; margin: 0 auto;" />
                  </p> -->
                </li>
              </ul>
            </div>

            <!--SEZIONE DETTAGLI -->
            <div v-if="sezioneDettagliVisible">
              <br />
              <b>Dettagli</b>
            </div>
            <div v-if="loadingSezioneDettagli" class="loader-centered" style="margin-top:20px;">
              <pulse-loader :loading="loadingSezioneDettagli" :color="colorSpinner">
              </pulse-loader>
            </div>
            <div v-if="sezioneDettagliVisible" id="carouselDettaglio" class="flexslider">
              <ul class="slides">
                <li v-for="video in videoDettaglio" :key="video.key" style="height:80px;">
                  <div v-if="video.imgThumbSource === undefined" class="loader-centered" style="margin-top:20px;">
                    <clip-loader :loading="video.imgThumbSource === undefined" :color="colorSpinner">
                    </clip-loader>
                  </div>
                  <a @click="openVideoDettaglio(video.ytVideoId)" v-show="video.imgThumbSource !== undefined">
                    <img style="height:80px;" alt="Youtube Video" :src="video.imgThumbSource" />
                    <div class="playButtonContainer">
                      <div class="playButton" style="background-image:url('/portals/0/images/play.png')">
                      </div>
                    </div>
                  </a>
                </li>
                <li v-for="immagine in imgDettaglio" :key="immagine.key">
                  <div v-if="immagine.imgFileName === undefined" class="loader-centered" style="margin-top:20px;">
                    <clip-loader :loading="immagine.imgFileName === undefined" :color="colorSpinner">
                    </clip-loader>
                  </div>
                  <a @click="showPopupImageZoom(immagine.imgFileName)" v-show="immagine.imgFileName !== undefined">
                    <img :alt="immagine.imgAltText" :title="immagine.imgTitle" :src="immagine.imgFileName"
                          class="pointer" style="border:1px solid lightgray;" />
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-xs-12 col-md-8" id="container-schema-prezzi-campione">
            <div class="row flex-container">
              <div class="col-xs-12 col-sm-6 flex-container-column" v-if="!schedaAppData.prodottoInfo.SeCategoriaFullCustom">
                <!-- Schema prezzi per il campione -->
                <div class="loader-centered" v-if="loadingPrezziCampione">
                  <pulse-loader :loading="loadingPrezziCampione" :color="colorSpinner">
                  </pulse-loader>
                </div>
                <div v-if="prezziCampioneData !== null && prodottoAcquistabileCampione" style="overflow-x:auto;">
                  <div style="margin-bottom: 5px;"><b>Prezzo per il campione</b></div>
                  <table class="tablePrezzi" style="width:100%;">
                    <tbody>
                      <tr>
                        <td>{{this.prezziCampioneData.LabelDescQuantita}}</td>
                        <td v-for="qta in this.prezziCampioneData.ListaQuantita" :key="qta.key">
                          <b>{{ qta }}</b>
                        </td>
                      </tr>
                      <tr v-if="!schedaAppData.prodottoInfo.SeCategoriaFullCustom && !schedaAppData.prodottoInfo.SeArtSoloPersonalizzabile">
                        <td :style="this.prezziCampioneData.ArticoloOutlet ? 'color:red;' : ''">{{this.prezziCampioneData.LabelDescPrezzi}}</td>
                        <td v-for="prezzo in this.prezziCampioneData.ListaPrezzi" :key="prezzo.key" :style="this.prezziCampioneData.ArticoloOutlet ? 'color:red;' : ''">
                          <span :style="!this.userInfo ? 'text-decoration:line-through' : ''">
                            {{prezzoToString(prezzo)}}
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div v-else>&nbsp;</div>
              </div>
              <div class="col-xs-12 col-sm-6 flex-container-column" v-else>
                &nbsp;
              </div>
              <div class="col-xs-12 col-sm-6 flex-container-column flex-item-center-x flex-item-center-y fastLinkInfo">
                <div style="margin-bottom: 5px;">&nbsp;</div>
                <!-- Pulsante Accedi/Calcola preventivo -->
                <template v-if="this.userInfo">
                  <input type="button" class="btnPrimary" @click="impostaVisualizzazioneScheda(false, true)" value="CALCOLA PREVENTIVO" />
                  <p v-if="!schedaAppData.prodottoInfo.SeCategoriaFullCustom && prodottoAcquistabileCampione" style="text-align: center;margin-top: 10px;">
                    <b>Vuoi vedere il prodotto prima di acquistarlo?</b><br /><a class="nav-link" @click="impostaVisualizzazioneScheda(true, true)">Ordina un campione</a>
                  </p>
                  <div v-else>&nbsp;</div>
                </template>
                <template v-else>
                  <input type="button" class="btnPrimary" @click="openLoginModal()" value="MOSTRAMI PREZZI RISERVATI" />
                  <p style="margin-top: 10px;text-align: center;"><a class="nav-link" @click="openLoginModal()">Registrati</a> o <a class="nav-link" @click="openLoginModal()">loggati</a> per vedere<br />i tuoi prezzi riservati</p>
                </template>
              </div>
            </div>
            <div style="margin-top: 70px;">
              <LineSeparator />
            </div>
            <div class="row withMarginTop">
              <div class="col-xs-3">
                <span style="font-weight:bold;">MULTIPLO D'ORDINE</span>
              </div>
              <div class="col-xs-3">
                {{this.schedaAppData.prodottoInfo.MultiploVendita}} pz
              </div>
              <div class="col-xs-2">
                <span style="font-weight:bold;">MATERIALE</span>
              </div>
              <div class="col-xs-4">
                {{this.schedaAppData.prodottoInfo.Materiale}}
              </div>
            </div>
            <div class="row withMarginTop" v-if="this.schedaAppData.prodottoInfo.Normativa.length > 0 || this.schedaAppData.prodottoInfo.Protezione">
              <div class="col-xs-3">
                <div v-if="this.schedaAppData.prodottoInfo.Normativa.length > 0">
                  <span style="font-weight:bold;">NORMATIVA</span>
                </div>
                <span v-else>&nbsp;</span>
              </div>
              <div class="col-xs-3">
                <div v-if="this.schedaAppData.prodottoInfo.Normativa.length > 0">
                  <span v-for="item in this.schedaAppData.prodottoInfo.Normativa" :key="item">{{ item }}<br /></span>
                </div>
                <span v-else>&nbsp;</span>
              </div>
              <div class="col-xs-2" v-if="this.schedaAppData.prodottoInfo.Protezione">
                <span style="font-weight:bold;">PROTEZIONE</span>
              </div>
              <div class="col-xs-4" v-if="this.schedaAppData.prodottoInfo.Protezione">
                {{this.schedaAppData.prodottoInfo.Protezione}}
              </div>
            </div>
            <div>
              <LineSeparator />
            </div>

            <div class="row withMarginTop" v-if="this.schedaAppData.prodottoInfo.Utilizzi.length > 0"> 
              <div class="col-xs-3">
                <span style="font-weight:bold;">IMPIEGHI</span>
              </div>
              <div class="col-xs-9">
                {{ this.schedaAppData.prodottoInfo.Utilizzi.join(', ') }}
              </div>
            </div>

            <div v-if="this.schedaAppData.prodottoInfo.Utilizzi.length > 0 && this.schedaAppData.prodottoInfo.ListaPersonalizzazioni.length > 0">
              <LineSeparator />
            </div>

            <div class="row withMarginTop" v-if="this.schedaAppData.prodottoInfo.ListaPersonalizzazioni.length > 0">
              <div class="col-xs-3">
                <span style="font-weight:bold;">PERSONALIZZAZIONI DISPONIBILI</span>
              </div>
              <div class="col-xs-9">
                <div v-for="pers in this.schedaAppData.prodottoInfo.ListaPersonalizzazioni" :key="pers.Codice">
                  {{ pers.Descrizione }}<span v-if="this.prezziData?.LabelDescPrezziConPers?.toLowerCase().includes(pers.Descrizione.toLowerCase())">*</span>,
                  da {{ pers.MinimoOrdine }} pz
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row" id="aggiungi-variante-section" style="margin-top:90px;">
          <div class="col-xs-12" v-if="!(!this.loadingSezioneMagazzini && this.datiMagazzini.length === 0 && this.magazzinoChecked === null)">
            <label style="font-size:large;margin-bottom:0;">{{ (this.userInfo ? 'CALCOLA PREVENTIVO | ACQUISTA' : '') }}</label>
          </div>
        </div>
        <div v-if="this.loadingSezioneMagazzini" class="withMarginTop">
          <clip-loader :loading="this.loadingSezioneMagazzini" :color="colorSpinner">
          </clip-loader>
        </div>
        <div v-if="(!this.loadingSezioneMagazzini && this.datiMagazzini.length === 0 && this.magazzinoChecked === null)" 
            style="color:red;" class="withMarginTop">
            <h4 style="color:red;"><b>ARTICOLO MOMENTANEAMENTE NON DISPONIBILE</b></h4>
            Per informazioni, potete contattarci al +39 02 33402817 o via Whatsapp.
        </div>
        <div class="row" v-else-if="!schedaAppData.prodottoInfo.SeCategoriaFullCustom && this.datiMagazzini.length > 0" style="margin-bottom:10px;">
          <div class="col-xs-12">
            <div class="preventivo-step">
              <span v-if="this.userInfo">Seleziona mittente</span>
              <label v-else style="font-size:large;margin-bottom:0;">DISPONIBILITÀ</label>
            </div>

            <!-- DATI MAGAZZINO -->
            <div v-for="(item, index) in datiMagazzini" :key="item.key" class="row" style="padding:20px 0px 0px 0px;"
            :style="index > 0 ? 'border-top: 1px solid lightgray;' : ''">
              <div class="col-xs-12 col-md-6">
                <div class="row">
                  <div class="col-xs-4">
                    Neutro spedito da:
                  </div>
                  <div class="col-xs-6">
                    <a v-if="item.datiExtra" data-toggle="popover" data-html="true" data-placement="top" data-container="body" title="" 
                      :data-content="item.datiExtra.indirizzo + `${item.datiExtra.comune ? `<br />${item.datiExtra.comune}` : ''}` + `${item.datiExtra.cap ? `<br />${item.datiExtra.cap}` : ''}`" 
                      class="popoverInfoMagazzino">
                      <label style="cursor:help;text-decoration:underline;">{{item.descrizione}}</label>
                    </a> 
                    <label v-else>{{item.descrizione}}</label>
                  </div>
                  <div class="col-xs-2" style="text-align: right;">
                    <input type="radio" name="radioMagazzino" style="cursor:pointer;"
                          :value="item.codice" :checked="index==0" @change="updateMagazzinoSelezionato(item, datiMagazzini)" />
                  </div>
                </div>
                <div class="row" v-if="schedaAppData.seVisualizzaDisponibilita">
                  <div class="col-xs-4">
                    Totale pezzi disponibili:
                  </div>
                  <div class="col-xs-8">
                    <span v-if="schedaAppData.prodottoInfo.SeCategoriaFullCustom" style="color:#028bff; font-weight:bold;">Realizzato a richiesta</span>
                    <span v-else-if="item.totaleStock == 0 && !item.seArriviPrevisti" style="color:red; font-weight:bold;">Non disponibile</span>
                    <span v-else>
                      <span class="linkDisponibilitaArriviPrevistiClass">{{ getDisponibilitaMagazzinoString(item) }}</span>&nbsp;
                      <a id="linkDisponibilitaArriviPrevisti" @click="disponibilitaModalShow(item)" class="linkDisponibilitaArriviPrevistiClass linkDisponibilitaArticolo">
                        Dettaglio completo
                      </a>
                    </span>
                  </div>
                </div>
                <div class="row withMarginTop withMarginBottom">
                  <div class="col-xs-12">
                    Colori disponibili:
                  </div>
                  <div class="col-xs-12">
                    <div v-if="loadingIconeColore" class="loader-centered" style="margin-top:20px;">
                      <pulse-loader :loading="loadingIconeColore" :color="colorSpinner">
                      </pulse-loader>
                    </div>
                    <div v-else class="icon-color-container">
                      <span v-for="varColore in item.variantiColore" :key="varColore.key">
                        <clip-loader :loading="varColore.imgFileName == ''" :color="colorSpinner" :size="'18px'">
                        </clip-loader>
                        <img :src="varColore.imgFileName" :title="varColore.descrizione" style="margin-left:5px; margin-top:5px;width:auto;"
                              v-if="varColore.imgFileName !== ''" />
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-md-6">
                <img src="/portals/0/images/ICON-truck-reverse.png" style="position: absolute; right:0; top:0; padding:15px 30px;" />
                <div style="padding:15px; background-color: #EEEEEE;">
                  <b>Ordinando oggi</b>
                  <div class="withMarginTop" v-if="!schedaAppData.prodottoInfo.SeCategoriaFullCustom">
                    <b>Evasione senza stampa:</b> {{item.dataEvasioneSenzaStampaString}}<br />
                    Giorni di transito: {{item.giorniConsegnaDestinazione}} gg da data di evasione
                  </div>
                  <div class="withMarginTop" v-if="schedaAppData.prodottoInfo.ListaPersonalizzazioni.length > 0">
                    <b>Evasione con stampa:</b> la data è elaborata quando è selezionata la stampa
                  </div>
                  <div class="withMarginTop">
                    <b>Hai una consegna tassativa?</b> contattaci allo 02 33402817<br />
                    prima di concludere l'ordine
                  </div>
                  <div class="withMarginTop">
                    <b>Spedizione:</b> {{ utenteAbbPrimeAttivo ? 'Gratis Top Delivery' : prezzoToString(item.prezzoSpedizione, 2)}}
                  </div>
                </div>
              </div>
              <div v-if="!this.userInfo" class="col-xs-12 col-md-offset-6 col-md-6 fastLinkInfo" style="margin-top: 20px; margin-bottom: 5px;">
                <div class="row">
                  <div class="col-xs-6" style="text-align: center;">
                    <span style="margin-right: 10px;"><a class="nav-link" @click="openLoginModal()">Registrati</a> o <a class="nav-link" @click="openLoginModal()">loggati</a> per vedere<br />i tuoi prezzi riservati</span>
                  </div>
                  <div class="col-xs-6">
                    <input type="button" class="btnPrimary" @click="openLoginModal()" value="MOSTRAMI PREZZI RISERVATI" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="this.userInfo && this.magazzinoChecked !== null" class="row" style="margin-top:20px;margin-bottom:10px;">
          <div class="col-xs-12">
            <div class="preventivo-step">
              {{this.sezioneAggiungiVarianteHeaderText}}
            </div>
            <div v-if="loadingVariantiProdotto" class="withMarginTop">
              <clip-loader :loading="loadingVariantiProdotto" :color="colorSpinner">
              </clip-loader>
            </div>
            <AggiungiVariante :listaMagazzini="this.datiMagazzini"
                              :datiMagazzino="this.magazzinoChecked" :seCampione="this.schedaModalitaAcquistoCampione" 
                              :qtaCampione="this.qtaCampione"
                              v-if="this.magazzinoChecked !== null"
                               />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12">
            <LineSeparator />
          </div>
        </div>
        <div class="row" id="dati-aggiuntivi-desc-lunga">
          <div class="col-xs-12">
            <!--DESCRIZIONE LUNGA PRODOTTO -->
            <label style="font-size:large;margin-bottom:0;">DESCRIZIONE COMPLETA</label><br />            
            <h3 style="margin-bottom:0;margin-top:0;font-size:16.5px;line-height:1.5;" v-html="this.schedaAppData.prodottoInfo.DesCata.replaceAll('\r', '<br />')"></h3>
          </div>
        </div>
        <div class="row" v-if="descErrataCorrige !== ''">
          <div class="col-xs-12">
            <!--ERRATA CORRIGE -->  
            <h3 style="margin-bottom:0;font-size:16.5px;line-height:1.5;"><b>Attenzione: </b><span v-html="descErrataCorrige"></span></h3>
          </div>
        </div>
        <div class="row withMarginTop">
          <div class="col-xs-12 col-md-6 withMarginBottom">
            <div>
              <ul class="nav nav-tabs" id="myTab" role="tablist"> 
                <li class="nav-item active" role="presentation">
                  <a class="nav-link active link-no-txt-decoration " id="dettagli-prodotto-tab" data-toggle="tab" href="#dettagli-prodotto" role="tab" aria-controls="dettagli-prodotto" aria-selected="true">Dettagli prodotto</a>
                </li>
                <li class="nav-item" role="presentation">
                  <a class="nav-link link-no-txt-decoration" id="dettagli-imballo-tab" data-toggle="tab" href="#dettagli-imballo" role="tab" aria-controls="dettagli-imballo" aria-selected="false">Dettagli imballo</a>
                </li>
              </ul>
              <div class="tab-content">
                <div class="tab-pane fade active in" id="dettagli-prodotto" role="tabpanel" aria-labelledby="dettagli-prodotto-tab">
                  <table class="tableDettagliProdotto">
                    <tr>
                      <td>Articolo</td>
                      <td>{{ dettagliProdotto.Articolo }}</td>
                    </tr>
                    <tr>
                      <td>Versione | Colore</td>
                      <td>{{ dettagliProdotto.VersioneColore }}</td>
                    </tr>
                    <tr>
                      <td>Nome</td>
                      <td>{{ dettagliProdotto.Nome }}</td>
                    </tr>
                    <tr>
                      <td>Marchio</td>
                      <td>{{ dettagliProdotto.Marchio }}</td>
                    </tr>
                    <tr>
                      <td>Materiale</td>
                      <td>{{ dettagliProdotto.Materiale }}</td>
                    </tr>
                    <tr>
                      <td>Misure</td>
                      <td>{{dettagliProdotto.Dimensioni }}</td>
                    </tr>
                  </table>
                </div>
                <div class="tab-pane fade" id="dettagli-imballo" role="tabpanel" aria-labelledby="dettagli-imballo-tab">
                  <table class="tableDettagliImballo" v-if="schedaAppData.prodottoInfo.NumLivVar > 1">
                    <tr>
                      <td>Taglia</td>
                      <td v-for="item in dettagliProdotto.Taglia" :key="item.key">
                        {{item}}
                      </td>
                    </tr>  
                    <tr>
                      <td>Confezione</td>
                      <td v-for="item in dettagliProdotto.Confezione" :key="item.key">
                        {{item}}
                      </td>
                    </tr>  
                    <tr>
                      <td>Misura del cartone cm</td>
                      <td v-for="item in dettagliProdotto.MisuraCartone" :key="item.key">
                        {{item}}
                      </td>
                    </tr>
                    <tr>
                      <td>Peso del cartone Kg</td>
                      <td v-for="item in dettagliProdotto.PesoCartone" :key="item.key">
                        {{item}}
                      </td>
                    </tr>
                  </table>
                  <table v-else class="tableDettagliImballo">
                    <tr>
                      <td>Confezione</td>
                      <td>{{ dettagliProdotto.Confezione[0] }}</td>
                    </tr>
                    <tr>
                      <td>Imballo</td>
                      <td>{{ dettagliProdotto.Imballo }}</td>
                    </tr>
                    <tr>
                      <td>Confezione interna</td>
                      <td>{{ dettagliProdotto.ConfezioneInterna }}</td>
                    </tr>
                    <tr>
                      <td>Misura del cartone cm</td>
                      <td>{{ dettagliProdotto.MisuraCartone[0] }}</td>
                    </tr>
                    <tr>
                      <td>Peso del cartone Kg</td>
                      <td>{{ dettagliProdotto.PesoCartone[0] }}</td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
            <div class="withMarginTop fastLinkInfo" id="dati-aggiuntivi-conformita">
              <label>Conformità</label><br />
              Codice doganale: {{schedaAppData.prodottoInfo.CodiceDoganale}}<br />
              Dichiarazione di conformità: <a @click="imageButtonDichiarazioneConformitaClick()">scarica qui</a><br />
              Test report: <a :href="`mailto:supplychain@generalmarketing.it?subject=Richiesta Test report Rif. ${schedaAppData.prodottoInfo.CodiceListino}`">richiedi qui</a><br />
              Dichiarazione di origine: <a :href="`mailto:supplychain@generalmarketing.it?subject=Richiesta Dichiarazione di origine Rif. ${schedaAppData.prodottoInfo.CodiceListino}`">richiedi qui</a>
            </div>
            <div class="row withMarginTop">
              <div class="col-xs-6">
                <!-- BUTTON DOWNLOAD SCHEDA PRODOTTO -->
                <a class="btn btn-warning btnPrimary" style="width:100%;" @click="imageButtonPdfSchedaClick()"
                  :style="(downloadingPdfScheda || !schedaAppData || !magazzinoChecked ? 'pointer-events:none;' : '')"
                  :disabled="(downloadingPdfScheda || !schedaAppData || !magazzinoChecked ? true : null)">
                  <i class="fa" :class="(downloadingPdfScheda ? 'fa-spinner fa-spin spin-faster fa-fw' : 'fa-download')" aria-hidden="true"></i><span style="padding-left: 10px;">SCHEDA PRODOTTO</span>
                </a>
              </div>
              <div class="col-xs-6">
                <!-- BUTTON DOWNLOAD IMMAGINI PRODOTTO -->
                <a class="btn btn-warning btnPrimary" style="width:100%;" @click="imageButtonImmaginiAltaRisClick()"
                   :style="(downloadingZipImmagini ? 'pointer-events:none;' : '')"
                   :disabled="(downloadingZipImmagini ? true : null)" >
                  <i class="fa" :class="(downloadingZipImmagini ? 'fa-spinner fa-spin spin-faster fa-fw' : 'fa-download')" aria-hidden="true"></i><span style="padding-left: 10px;">IMMAGINI HD</span>
                </a>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-6" style="text-align:center;">
            <div v-if="this.imgPianoTaglie !== null && this.imgPianoTaglie.imgSrcRelativePath === undefined" class="loader-centered" style="margin-top:20px;">
              <clip-loader :loading="this.imgPianoTaglie.imgSrcRelativePath === undefined" :color="colorSpinner">
              </clip-loader>
            </div>
            <img v-if="this.imgPianoTaglie !== null" class="img-responsive" :alt="this.imgPianoTaglie.imgAltText" :title="this.imgPianoTaglie.imgTitle" :src="this.imgPianoTaglie.imgSrcRelativePath" />
          </div>
        </div>
        <div v-if="!this.userInfo && !this.schedaAppData.prodottoInfo.SeCategoriaFullCustom" class="row withMarginTop">
          <div class="col-xs-12 fastLinkInfo withMarginTop withMarginBottom" style="display: flex;justify-content: center;align-items: center;flex-direction: column;">
            <span style="margin-right: 10px;">I prezzi esposti sono quelli consigliati al pubblico, ma puoi accedere a un <a class="nav-link" @click="openLoginModal()">prezzo riservato</a></span>
            <input type="button" class="btnPrimary withMarginTop" @click="openLoginModal()" value="ACCEDI AI PREZZI SCONTATI" />
          </div>
        </div>
        <div class="row withMarginTop">
          <div class="col-xs-12">
            <LineSeparator />
          </div>
        </div>
        <div class="row" style="margin-bottom:50px;">
          <div class="col-xs-12">
            <label>Cerchi articoli simili? Altri utenti hanno acquistato anche questi</label>
            <div v-if="loadingSezioneArtAlternativi" class="loader-centered" style="margin-top:20px;">
              <pulse-loader :loading="loadingSezioneArtAlternativi" :color="colorSpinner">
              </pulse-loader>
            </div>
            <div id="carouselAlternativi" class="flexslider">
              <br />
              <ul class="slides">
                <li v-for="articolo in artAlternativi" :key="articolo.key">
                  <div v-if="articolo.imgFileName === undefined" class="loader-centered" style="margin-top:20px;">
                    <clip-loader :loading="articolo.imgFileName === undefined" :color="colorSpinner">
                    </clip-loader>
                  </div>
                  <a :href="articolo.urlScheda" v-show="articolo.imgFileName !== undefined">
                    <img :alt="articolo.imgAltText" :title="articolo.imgTitle" :src="articolo.imgFileName" />
                  </a> 
                </li>
              </ul>
            </div>
          </div>
        </div>

        <!--DATI DISPONIBILITA VARIANTI-->
        <custom-modal v-model="showDisponibilitaModal" name="disponibilitaModal" :click-to-close="false" @closed="disponibilitaModalClosed">  <!-- @confirm="confirm" @cancel="cancel" -->
          <template v-slot:title>Deposito {{this.magazzinoDataSelectedToShowModal !== null ? this.magazzinoDataSelectedToShowModal.descrizione : '-'}}</template>
          <VariantiDisponibilita :codListino="this.codListino" :magazzinoData="this.magazzinoDataSelectedToShowModal" :variantiProdotto="this.variantiProdInfo"
            :onDataLoaded="disponibilitaDataLoaded" v-if="loadDisponibilitaModalComponent"  />
        </custom-modal>
        <!--DATI DISPONIBILITA VARIANTI-->

        <!--VIDEO CONTAINER-->
        <custom-modal v-model="showVideoZoomModal" name="videoZoomModal" :click-to-close="false" @closed="onCloseVideoDettaglio">
          <template v-slot:title>Dettaglio video</template>
          <!-- https://www.npmjs.com/package/vue3-youtube -->
          <YouTube ref="youtube" :src="selectedVideoId" v-if="selectedVideoId !== ''" />
        </custom-modal>
        <!--VIDEO CONTAINER-->

        <!--ZOOM IMMAGINI DETTAGLIO-->
        <custom-modal v-model="showImageZoomModal" name="imageZoomModal" :click-to-close="false">
          <template v-slot:title>Dettaglio immagine</template>
          <img id="ImageDettaglioZoom" src="" title="" />
        </custom-modal>
        <!--ZOOM-->

        <!--SERVIZIO GM PRIME-->
        <custom-modal v-model="showGMPrime" name="gmPrimeModal" :click-to-close="false">
          <template v-slot:title></template>
          <ServizioInfo v-if="loadPrimeContent" title="TOP DELIVERY" desc1="Ordina senza pensieri e spedisci tutti i tuoi ordini gratuitamente."
                        desc2="Spedizioni illimitate | Importi illimitati | Quantità illimitate" :showCheckRicordaScelta="true" 
                        @close-popup-servizi="closePopupServizi" @insert-servizio-ok="insertServizioOk" />
        </custom-modal>

        <!-- LOGIN MODAL -->
        <custom-modal v-model="showUserLoginModal" name="customModalUserLogin" :click-to-close="false" @opened="modalLoginOpened" v-if="!this.userInfo">
            <template v-slot:title><h1 style="color:#004F87;margin-top:-10px;">SCOPRI IL TUO ARTICOLO CON <b>PREZZO SCONTATO</b></h1></template>
            <LoginUser @user-login-success="loginSuccess" @btn-register-clicked="openRegisterModal" @btn-send-pwd-clicked="openSendPwdModal" />
        </custom-modal>

        <!-- REGISTRAZIONE MODAL -->
        <custom-modal v-model="showUserRegistrationInModal" name="customModalUserRegistration" v-if="!this.userInfo"
                  :click-to-close="false" :drag="true" :fit-parent="true" :min-height="300" :min-width="430" :resize="true"
                  @opened="modalUserRegistrationOpened" @closed="modalUserRegistrationClosed" @resize:move="modalUserRegistrationResizeMove">
            <template v-slot:title><h1 style="color:#004F87; text-align: center;">CI SEI QUASI! COMPILA IL FORM<br/>E SCOPRI IL TUO ARTICOLO A PREZZO SCONTATO</h1></template>
            <div>
                <iframe id="iframeReg" :src="dnnAppData.urlPaginaRegistrazione" scrolling="no" width="800px" :onload="iframeRegOnLoad"></iframe>
            </div>
        </custom-modal>

        <!-- SEND PASSWORD MODAL -->
        <custom-modal v-model="showSendPasswordionInModal" name="customModalSendPassword" v-if="!this.userInfo"
                    :click-to-close="false" :drag="true" :fit-parent="true" :min-height="300" :min-width="430" :resize="true"
                    @opened="modalSendPasswordOpened" @closed="modalSendPasswordClosed" @resize:move="modalSendPasswordResizeMove">
            <template v-slot:title>Dimenticato la password?</template>
            <div>
                <iframe id="iframeSendPwd" :src="dnnAppData.urlPaginaSendPassword" scrolling="no" width="800px" :onload="iframeSendPwdOnLoad"></iframe>
            </div>
        </custom-modal>
    </div>
</template>

<script> 
// @ is an alias to /src
import { defineAsyncComponent } from 'vue'
import webApiProxy from "@/services/webApiProxy.js";
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import ClipLoader from 'vue-spinner/src/ClipLoader.vue'
import schedaJs from "@/scripts/Scheda.js"
import commonJs from "@/scripts/common.js"
import {VariantiColore} from "@/scripts/models/VariantiColore.js";
import {VideoDettaglioItem} from "@/scripts/models/VideoDettaglioItem.js";
import {ImageDettaglioItem} from "@/scripts/models/ImageDettaglioItem.js";
import {ArtAlternativoItem} from "@/scripts/models/ArtAlternativoItem.js";
import YouTube from 'vue3-youtube';
import CustomModal from '@/components/CustomModal.vue';
import Cookies from "js-cookie";

let $ = window.$;

// per utilizzare jquery e jquery-ui correttamente:
//https://www.programmerall.com/article/16382181379/
//import 'jquery-ui-dist/jquery-ui'
//import 'jquery-ui-dist/jquery-ui.min.css'

export default {
  name: "SchedaView",
  data(){
    return {
      colorSpinner:'#004F87',
      loadingPrezzi: false,
      loadingPrezziCampione: false,
      loadingSezioneColori:false,
      loadingSuDisponibilitaTotale:false,
      loadingSezioneDettagli:false,
      loadingSezioneArtAlternativi:false,
      loadingIconeColore:false,
      loadingSezioneMagazzini:false,
      downloadingPdfScheda:false,
      downloadingZipImmagini:false,
      showDisponibilitaModal: false,
      loadDisponibilitaModalComponent: false,
      showImageZoomModal: false,
      showVideoZoomModal: false,
      dnnAppData: window.dnnAppData,
      listaVariantiColore: [],
      videoDettaglio: [],
      imgDettaglio: [],
      selectedVideoId: '',
      imgPianoTaglie:new ImageDettaglioItem(),
      artAlternativi: [],
      totPzDisponibiliTutteVarianti:0,
      datiMagazzini: [],
      magazzinoDataSelectedToShowModal:null,
      prezziData:null,
      prezziCampioneData:null,
      prodottoAcquistabileCampione:false,
      schedaModalitaAcquistoCampione:false,
      qtaCampione:0,
      loadingVariantiProdotto:false,
      showGMPrime:false,
      loadPrimeContent:false,
      showUserLoginModal: false,
      showUserRegistrationInModal: false,
      showSendPasswordionInModal: false,
      currentVarColoreImageUrl: '',
      currentVarColoreZoomImageUrl: '',
      currentVarColoreDescColore:'',
      currentVarColoreAltText: '',
      currentVarCodVar1: '',
    };
  },
  props:{
    category : String,
    codListino : String,
  },
  components: {
    //Product,
    PulseLoader,
    ClipLoader,
    YouTube,
    CustomModal,
    LoginUser: defineAsyncComponent(() =>
      import('@/components/LoginUser.vue')
    ),
    AggiungiVariante: defineAsyncComponent(() => 
      import('@/components/AggiungiVariante.vue')
    ),
    VariantiDisponibilita: defineAsyncComponent(() => 
      import('@/components/VariantiDisponibilita.vue')
    ),
    ServizioInfo:  defineAsyncComponent(() => 
      import('@/components/ServizioInfo.vue')
    ),
  },
  computed: {
    schedaAppData() {
      return this.$store.state.schedaAppData;
    },
    userInfo(){
      return this.$store.state.loggedUserInfo;
    },
    magazzinoChecked(){
      return this.$store.state.datiMagazzino;
    },
    variantiProdInfo(){
      return this.$store.state.variantiProdotto;
    },
    imgProdottoAlt: function(){
      return `${this.schedaAppData.prodottoInfo.Descrizione} ${this.schedaAppData.prodottoInfo.CodiceListino} - ${this.schedaAppData.prodottoInfo.Colore}`;
    },
    currentUrl:function() {
      return window.location.href;
    },
    visualizzaPrezzoContainer: function(){
      return this.schedaAppData.seVisualizzaPrezzo && !this.schedaAppData.prodottoInfo.SeCategoriaFullCustom;
    },
    totDisponibilitaFormattedString: function(){
      return `Tot. ${commonJs.numberToString(this.totPzDisponibiliTutteVarianti)} pz`;
    },
    sezioneAggiungiVarianteHeaderText(){
      if(this.schedaModalitaAcquistoCampione){
        return `Compila: per questo articolo la minima campionatura è ${this.qtaCampione} ${this.qtaCampione > 1 ? 'pezzi' : 'pezzo'} per versione | colore`;
      }
      else{
        return `Compila ordine | ${this.prezziData != null && this.prezziData.ListaQuantita ? `Ordine minimo ${this.prezziData.ListaQuantita[0]} pz | ` : ''}Multipli d'ordine ${this.schedaAppData.prodottoInfo.MultiploVendita} pz`;
      }
    },
    utenteAbbPrimeAttivo(){
      return commonJs.seUtenteCorrenteConTipoServizioAttivo(commonJs.COD_TIPO_SERVIZIO_PRIME);
    },
    sezioneDettagliVisible(){
      //return false;
      return this.videoDettaglio?.length > 0 || this.imgDettaglio?.length > 0;
    },
    brand(){
      return this.schedaAppData.prodottoInfo.MarchioInvariante.trim().toLowerCase() !== "nessuno" && this.schedaAppData.prodottoInfo.MarchioInvariante !== '' 
          ? this.schedaAppData.prodottoInfo.MarchioInvariante : '';
    },
    imbustoInterno(){
      return (this.schedaAppData.prodottoInfo.ImbustoInterno === 0 ? '': `${this.schedaAppData.prodottoInfo.ImbustoInterno} pz`);
    },
    imballo() {
      return (this.schedaAppData.prodottoInfo.ImbustoMaster === 0 ? '' : `${this.schedaAppData.prodottoInfo.ImbustoMaster} pz`);
    },
    descErrataCorrige(){
      if(this.schedaAppData.prodottoInfo.DescrizioneErrataCorrige !== ''){
        return this.schedaAppData.prodottoInfo.DescrizioneErrataCorrige.charAt(0).toLocaleLowerCase() + this.schedaAppData.prodottoInfo.DescrizioneErrataCorrige.slice(1);
      }
      return '';
    },
    dettagliProdotto(){

      var currProd = this.variantiProdInfo.filter(x => x.CodVar1 === this.currentVarCodVar1)[0];
      if(currProd === undefined){
        currProd = this.schedaAppData.prodottoInfo;
      }

      return {
        Articolo: currProd.CodiceListino,
        VersioneColore:  currProd.CodVar1 + ' - ' + currProd.DesValoreVar1,
        Nome: currProd.CodName,
        Marchio: currProd.MarchioInvariante,
        Materiale: currProd.Materiale,
        Dimensioni: currProd.Dimensioni,

        Taglia: currProd.NumLivVar > 1 ? this.variantiProdInfo.filter(x => x.CodVar1 === currProd.CodVar1).map(x => x.DesValoreVar2) : [],
        Confezione: currProd.NumLivVar > 1 ? this.variantiProdInfo.filter(x => x.CodVar1 === currProd.CodVar1).map(x => x.Confezione) : [ currProd.Confezione ],
        MisuraCartone: currProd.NumLivVar > 1 ? this.variantiProdInfo.filter(x => x.CodVar1 === currProd.CodVar1).map(x => x.DimensioniCollo) : [ currProd.DimensioniCollo ],
        PesoCartone: currProd.NumLivVar > 1 ? this.variantiProdInfo.filter(x => x.CodVar1 === currProd.CodVar1).map(x => x.PesoCollo) : [ currProd.PesoCollo === 0 ? '' : `${currProd.PesoCollo}` ],
        Imballo: currProd.NumLivVar > 1 ? '' : this.imballo,
        ConfezioneInterna: currProd.NumLivVar > 1 ? '' : this.imbustoInterno,

      };
    }
    /*prezzoClass() {
      if(!this.schedaAppData.sePrezzoSuRichiesta && !this.dnnAppData.isAuthenticated){
        return {
          lblPrezzoStrikeout: true
        }
      } 
      else {
        if(this.schedaAppData.sePrezzoSuRichiesta || this.schedaAppData.sePrezziDifferenti){
          return {
            lblPrezzoUnderlinePointer: true
          }
        } else{
          return {}
        }
      }
    }*/
  },
  methods: {
    
    /*LOGIN POPUP FUNCTIONS */
    modalLoginOpened(){
        //alert('Modal Login opened!');
        this.hideDnnThemeHeaderAndFooter('#iframeReg');
        this.hideDnnThemeHeaderAndFooter('#iframeSendPwd');
    },
    hideDnnThemeHeaderAndFooter(iframeContainerId){
        window.$(iframeContainerId).contents().find('#HeaderMain').css('display', 'none');
        window.$(iframeContainerId).contents().find('.ESHOPMEGAMENUZONE').css('display', 'none');
        window.$(iframeContainerId).contents().find('.FooterMain').css('display', 'none');
    },
    modalUserRegistrationOpened(){
        const modalReg = this.$vfm.get('customModalUserRegistration')[0];
        window.$(modalReg.vfmContent._value).find('.modal__content')[0].scrollTo(0,0);
        this.adjustIframeSize("#iframeReg");
    },
    modalUserRegistrationClosed(){
        window.$("#iframeReg")[0].src = '';
        window.$("#iframeReg")[0].contentWindow.location.replace(this.dnnAppData.urlPaginaRegistrazione);
        //window.$("#iframeReg")[0].contentWindow.location.reload();
    },
    modalUserRegistrationResizeMove(){  //evt
        const modalReg = this.$vfm.get('customModalUserRegistration')[0];
        window.$("#iframeReg")[0].style.width = (parseFloat(modalReg.vfmContent._value.style.width)-45) + 'px';
        window.$("#iframeReg")[0].style.height = (window.$("#iframeReg")[0].contentDocument.body.scrollHeight+25) + 'px';
    },
    iframeRegOnLoad(evt){
        //console.log("iframe Reg Loaded!!!");
        if(evt.target.contentWindow.location.href !== this.dnnAppData.urlPaginaRegistrazione){
            //console.log('iframe reg. href changed to: ' + evt.target.contentWindow.location.href);
            this.hideDnnThemeHeaderAndFooter("#iframeReg");
            this.adjustIframeSize("#iframeReg");
        }
    },
    modalSendPasswordOpened(){
        const modalSendPwd = this.$vfm.get('customModalSendPassword')[0];
        window.$(modalSendPwd.vfmContent._value).find('.modal__content')[0].scrollTo(0,0);
        this.adjustIframeSize("#iframeSendPwd");
    },
    modalSendPasswordClosed(){
        window.$("#iframeSendPwd")[0].src = '';
        window.$("#iframeSendPwd")[0].contentWindow.location.replace(this.dnnAppData.urlPaginaSendPassword);
        //window.$("#iframeSendPwd")[0].contentWindow.location.reload();
    },
    modalSendPasswordResizeMove(){
        const modalSendPwd = this.$vfm.get('customModalSendPassword')[0];
        window.$("#iframeSendPwd")[0].style.width = (parseFloat(modalSendPwd.vfmContent._value.style.width)-45) + 'px';
        window.$("#iframeSendPwd")[0].style.height = (window.$("#iframeSendPwd")[0].contentDocument.body.scrollHeight+25) + 'px';
    },
    iframeSendPwdOnLoad(evt){
        //console.log("iframe Send Pwd Loaded!!!");
        if(evt.target.contentWindow.location.href !== this.dnnAppData.urlPaginaSendPassword){
            //console.log('iframe reg. href changed to: ' + evt.target.contentWindow.location.href);
            this.hideDnnThemeHeaderAndFooter("#iframeSendPwd");
            this.adjustIframeSize("#iframeSendPwd");
        }
    },
    adjustIframeSize(iframeId){
        window.$(iframeId)[0].style.height = (window.$(iframeId)[0].contentDocument.body.scrollHeight+25) + 'px';
        window.$(iframeId)[0].style.width = (window.$(iframeId)[0].contentDocument.body.scrollWidth+25) + 'px';
    },
    openLoginModal(){
      this.$vfm.show('customModalUserLogin');
    },
    openRegisterModal(){
        this.$vfm.hide('customModalUserLogin');
        this.$vfm.show('customModalUserRegistration');
    },
    openSendPwdModal(){
        this.$vfm.hide('customModalUserLogin');
        this.$vfm.show('customModalSendPassword');
    },
    loginSuccess(userLoginData) {
        console.log('Emit login component event!');
        console.log(userLoginData);
        this.$vfm.hide('customModalUserLogin');

        //TODO: reload the page with data as logged user
        document.location = this.currentUrl;
    },
    /*LOGIN POPUP FUNCTIONS */
    
    updateMagazzinoSelezionato(magazzinoData, listaMagazziniData){
      this.$store.dispatch('setMagazzinoSelezionato', magazzinoData);
      this.$store.dispatch('setListaMagazzini', listaMagazziniData);
    },
    disponibilitaModalShow(magazzinoData){
      this.magazzinoDataSelectedToShowModal = magazzinoData;
      this.loadDisponibilitaModalComponent = true; //async loaded
      this.$vfm.show('disponibilitaModal');
    },
    disponibilitaModalClosed: function(){
      this.loadDisponibilitaModalComponent = false;
    },
    disponibilitaDataLoaded: function(){
      //se può servire... questo evento scatta al completamento del caricamento del componente VariantiDisponibilita.vue
    },    
    linkWhatsAppClick: function(){
      schedaJs.openPageNewTab(this.schedaAppData.whatsAppBtnUrlRedirect);
    },
    prezzoToString(price, numberOfDigits = 3) {
      return `${commonJs.piceToString(price, numberOfDigits)}`;
    },
    prezzoToString_NoCurrency(price, numberOfDigits = 3) {
        return `${commonJs.piceToString_noCurrency(price, numberOfDigits)}`;
    },
    numberToString(number){
      return `${commonJs.numberToString(number)}`;
    },
    getDisponibilitaMagazzinoString(magazzinoData){
      if(magazzinoData.totaleStock > 0 && magazzinoData.seArriviPrevisti){
        if(this.schedaAppData.prodottoInfo.DisponibilitaMassimaTotale > 0 && magazzinoData.totaleStock > this.schedaAppData.prodottoInfo.DisponibilitaMassimaTotale)
          return `Più di ${this.numberToString(this.schedaAppData.prodottoInfo.DisponibilitaMassimaTotale)} pz + arrivi`;
        else
          return `${this.numberToString(magazzinoData.totaleStock)} pz + arrivi`;
      }
      else if(magazzinoData.totaleStock > 0 && !magazzinoData.seArriviPrevisti){
        if(this.schedaAppData.prodottoInfo.DisponibilitaMassimaTotale > 0 && magazzinoData.totaleStock > this.schedaAppData.prodottoInfo.DisponibilitaMassimaTotale)
          return `Più di ${this.numberToString(this.schedaAppData.prodottoInfo.DisponibilitaMassimaTotale)}`;
        else
          return `${this.numberToString(magazzinoData.totaleStock)}`;
      }
      else if(magazzinoData.totaleStock == 0 && magazzinoData.seArriviPrevisti){
        return `In arrivo`;
      }
    },
    showPopupImageZoom(imageZoomFullFilePath){
      $("#ImageDettaglioZoom").attr("src", imageZoomFullFilePath);
      this.$vfm.show('imageZoomModal');
    },
    openVideoDettaglio(youtubeVideoId){
      this.selectedVideoId = youtubeVideoId;
      this.$vfm.show('videoZoomModal');
    },
    onCloseVideoDettaglio: function(){
      this.selectedVideoId = '';
    },
    async imageButtonPdfSchedaClick(){
      this.downloadingPdfScheda = true;
      
      let requestDto = {
        //NomeArticolo: `${this.schedaAppData.prodottoInfo.MarchioInvariante} ${this.schedaAppData.prodottoInfo.CodName}`,
        CodiceArticolo: this.schedaAppData.prodottoInfo.CodiceArticolo,
        CodiceListino: this.schedaAppData.prodottoInfo.CodiceListino,
        Descrizione: this.schedaAppData.prodottoInfo.Descrizione,
        // DescrizioneSeo: this.schedaAppData.prodottoInfo.DescrizioneSEO,
        // DescrizioneCompleta: this.schedaAppData.prodottoInfo.DesCata.replaceAll('\r', '<br />'),
        // MultipliOrdine: `${this.schedaAppData.prodottoInfo.MultiploVendita} pz`,
        Materiale: this.schedaAppData.prodottoInfo.Materiale,
        //CodiceDoganale: this.schedaAppData.prodottoInfo.CodiceDoganale,
        ImgArticoloFullPath: this.schedaAppData.imgProdottoImageUrl,
        //ImgDettaglioFullPath: this.imgPianoTaglie ? this.imgPianoTaglie.imgSrcRelativePath : '',
        //VariantiColore: this.datiMagazzini.map(x => x.variantiColore).flat(1), //this.magazzinoChecked.variantiColore,
        Brand: this.brand,
        Normativa: this.schedaAppData.prodottoInfo.Normativa.join(' - '),
        Protezione: this.schedaAppData.prodottoInfo.Protezione,
        Impieghi: this.schedaAppData.prodottoInfo.Utilizzi.join(', '),
        Confezione: this.schedaAppData.prodottoInfo.Confezione.toString(),
        Imballo: this.imballo,
        ConfezioneInterna: this.imbustoInterno
      };

      await webApiProxy.downloadPdfSchedaProdotto(requestDto).then((res) =>{
        if(res.status == 200){
          let outFileName = `${this.schedaAppData.prodottoInfo.CodiceArticolo.replaceAll(',', '-')}_Scheda.pdf`;
          let contentType = 'application/pdf';
          this.downloadData(res.data, contentType, outFileName);
        } else{
          alert("Impossibile scaricare l'allegato.");
        }
      }).catch(function (error) {
        // handle error
        console.log(error);
        alert("Si è verificato un errore. Impossibile scaricare l'allegato.");
      });
        
      this.downloadingPdfScheda = false;
    },
    imageButtonImmaginiAltaRisClick(){
      this.downloadingZipImmagini = true;
      let basePathImmaginiDettaglioZoomHD = this.schedaAppData.basePathImmaginiDettaglioZoomHD;
      let outFileName = `${this.codListino}_${this.schedaAppData.prodottoInfo.CodName.trim().toLowerCase()}_images.zip`;
      let contentType = 'application/zip';
      webApiProxy.downloadImmaginiProdotto(
        this.codListino, this.schedaAppData.prodottoInfo.CodName,
        this.listaVariantiColore.map((x) => x.imgFileName),
        this.schedaAppData.prodottoInfo.ListaImmagini,
        basePathImmaginiDettaglioZoomHD)
      .then((res) =>{
        if(res.status == 200){
          this.downloadData(res.data, contentType, outFileName.replaceAll(' ', ''));
        } else{
          alert("Impossibile scaricare l'allegato.");
        }
      }).catch(function (error) {
        // handle error
        console.log(error);
        alert("Impossibile scaricare l'allegato.");
      }).then(() => {
        this.downloadingZipImmagini = false;
      });
    },
    imageButtonDichiarazioneConformitaClick(){
      let relativeFilePathToDownload = this.schedaAppData.dichiarazioneConformitaRelativeFilePath;
      let outFileName = `dichiarazione-conformita-${this.codListino}.pdf`;
      let contentType = 'application/pdf';
      webApiProxy.downloadFileFromRelativePath(relativeFilePathToDownload, outFileName, contentType).then((res) =>{
          if(res.status == 200){
            this.downloadData(res.data, contentType, outFileName);
          } else{
            alert("Impossibile scaricare l'allegato.");
          }
        }).catch(function (error) {
          // handle error
          console.log(error);
          alert("Impossibile scaricare l'allegato.");
        });
    },
    // downloadPersData(codPers){
    //   if(this.userInfo) { //this.dnnAppData.isAuthenticated
    //     webApiProxy.downloadFilePersonalizzazione(codPers).then((res) => {
    //       if(res.status == 200){
    //         this.downloadData(res.data, "application/pdf", `${codPers}.pdf`);
    //       } else{
    //         alert("Impossibile scaricare l'allegato.");
    //       }
    //     }).catch(function (error) {
    //       // handle error
    //       console.log(error);
    //       alert("Impossibile scaricare l'allegato.");
    //     });
    //   }
    // },
    downloadData(data, contentType, fileName){
      const blob = new Blob([data], { type: contentType });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
      URL.revokeObjectURL(link.href);
    },
    loadSezionePrezzi() {
      this.loadingPrezzi = true;
      let idAzienda = this.userInfo ? this.userInfo.IdAzienda : -1;
      webApiProxy.getSezionePrezzi(this.schedaAppData.prodottoInfo.CodiceArticolo, idAzienda, /*soloCampione*/false).then(resPrezzi => {
        console.log(`Prezzi caricato per idAzienda: ${idAzienda} per articolo [Base]`);
        this.prezziData = resPrezzi.data;
        this.loadingPrezzi = false;
      });
    },
    loadSezionePrezziCampione(){
      this.loadingPrezziCampione = true;
      let idAzienda = this.userInfo ? this.userInfo.IdAzienda : -1;
      webApiProxy.getSezionePrezzi(this.schedaAppData.prodottoInfo.CodiceArticolo, idAzienda, /*soloCampione*/true).then(resPrezzi => {
        console.log(`Prezzi caricato per idAzienda: ${idAzienda} per articolo [Campione neutro]`);

        if(resPrezzi.data.ListaQuantita.length > 0){
          this.prodottoAcquistabileCampione = true;
          this.qtaCampione = resPrezzi.data.ListaQuantita[0];
        }

        this.prezziCampioneData = resPrezzi.data;
        this.loadingPrezziCampione = false;
      });
    },
    impostaVisualizzazioneScheda(seVisualizzazioneCampioneNeutro, scrollToSection) {
      this.schedaModalitaAcquistoCampione = seVisualizzazioneCampioneNeutro;
      //this.loadSezionePrezzi(seVisualizzazioneCampioneNeutro);

      if(scrollToSection){
        let elemScrollTo = document.getElementById('aggiungi-variante-section');
        elemScrollTo.scrollIntoView({ behavior: "smooth" });
      }
    },
    closePopupServizi() {
      this.$vfm.hide('gmPrimeModal');
    },
    insertServizioOk() {
      this.$router.push({
          name: "CarrelloView"
      });
    },
    btnLoginPageClicked() {
      document.location = `/Accesso?returnurl=${this.currentUrl}`;
    },
    loadMainImgVarianteColore(item){
      this.currentVarColoreDescColore = item.popOverText;
      this.currentVarColoreImageUrl = item.imgFileName;
      this.currentVarColoreZoomImageUrl = item.imgFileNameZoom;
      this.currentVarColoreAltText = item.imgAltText;
      this.currentVarCodVar1 = item.codVar1;
    }
  },
  // async beforeRouteEnter(routeTo, routeFrom, next) {
    
    
  // },
  async created(){ 

    this.currentVarColoreImageUrl = this.schedaAppData.imgProdottoImageUrl;
    this.currentVarColoreZoomImageUrl = this.schedaAppData.imgProdottoImageUrlZoom;
    this.currentVarColoreDescColore = this.schedaAppData.prodottoInfo.DesValoreVar1;
    this.currentVarColoreAltText =  `${this.schedaAppData.prodottoInfo.Descrizione} ${this.schedaAppData.prodottoInfo.CodiceListino}`;

    //Load data...
    //qui recupero SOLO le varianti prodotto che sto visualizzando.
    //
    this.loadingSezioneMagazzini = true;
    this.loadingVariantiProdotto = true;
    await webApiProxy.getVariantiProdotto(this.codListino, this.dnnAppData.schedaSettings)
      .then(res =>{
        this.$store.dispatch('setVariantiProdotto', res.data);
        //this.variantiProdInfo = res.data;
      })
      .catch(error => {
          console.log(error);
          this.$store.dispatch('setVariantiProdotto', []);
          this.$router.push({
              name: "ErrorDisplay",
              props: error
          });
      });
    
    this.loadingVariantiProdotto = false;

    // in questo momento non mi serve l'id azienda.
    // AAA: Con 4bytes abbiamo concordato che usiamo questa chiamata per sapere se 
    // questa questo prodotto posso acquistarlo come Campione!!!
    // let idAzienda = -1;
    // webApiProxy.getSezionePrezzi(this.schedaAppData.prodottoInfo.CodiceArticolo, idAzienda, true)
    //   .then(resPrezzi => {
    //     if(resPrezzi.data.ListaQuantita.length > 0){
    //       this.prodottoAcquistabileCampione = true;
    //       this.qtaCampione = resPrezzi.data.ListaQuantita[0]
    //     }
    //   });

    //Carico la Tabella prezzi
    this.loadSezionePrezzi();
    this.loadSezionePrezziCampione();
    
    //Versioni/colori
    this.loadingSezioneColori = true;
    this.loadingSuDisponibilitaTotale = true;

    let allCodVar1 = [];
    const varGrouped = this.variantiProdInfo.reduce((acc, curr) => {
      if(!acc[curr.CodVar1]){
          acc[curr.CodVar1] = []; //If this type wasn't previously stored
          allCodVar1.push(curr.CodVar1);
      }
      acc[curr.CodVar1].push(curr);
      return acc;
    },{});

    allCodVar1.forEach(codVar => {
      let prodListByCodVar = varGrouped[codVar];
      let firstElem = prodListByCodVar[0];

      let model = new VariantiColore();
      // model.pzDisponibili = totPzDisponibili;
      // model.pzOpzionati = totPzOpzionati;
      model.imgFileName = firstElem.ImmagineFileName;
      model.imgFileNameZoom = firstElem.ImmagineZoomFileName;
      model.popOverText = `${firstElem.DesValoreVar1}`;
      model.imgAltText = `${firstElem.Descrizione} colore ${firstElem.Colore}`;
      model.imgTitle = `${firstElem.Colore}`;
      model.urlScheda = `${this.schedaAppData.prodottoBaseUrl}?codvar=${firstElem.CodVar1}`;
      model.codVar1 = firstElem.CodVar1;
      this.listaVariantiColore.push(model);
    });
    
    this.loadingSezioneColori = false;
    this.loadingSuDisponibilitaTotale = false;

    setTimeout(() => {  //necessario il setTimeout perchè troppo veloce, altrimenti schedaJs.initFlexSlider_SezioneVarianti(); non riesce a creare lo slider
      schedaJs.initFlexSlider_SezioneVarianti();

      $(".popoverVarianti").popover({
        container: 'body',
        trigger: 'hover',
      });  
    }, 10);

    //Sezione Dettagli
    this.loadingSezioneDettagli = true;
    this.videoDettaglio =
      this.schedaAppData.prodottoInfo.ListaVideo.map((dto) => {
        let url = new URL(dto.UrlCompleto);
        let urlParams = new URLSearchParams(url.search);
        let videoId = urlParams.get('v');

        let videoModel = new VideoDettaglioItem();
        videoModel.ytVideoId = videoId;
        videoModel.imgThumbSource = `https://i.ytimg.com/vi/${videoId}/sddefault.jpg`;
        return videoModel;
      });

    this.imgDettaglio =
      this.schedaAppData.prodottoInfo.ListaImmagini
      .filter(dto => dto.TipoImmagineEnum == commonJs.tipoImmagineEnum.Details)
      .map((dto, index) => {
        let imgModel = new ImageDettaglioItem();
        imgModel.imgAltText = `Dettaglio ${index + 1} ${this.schedaAppData.prodottoInfo.Descrizione}`;
        imgModel.imgFileName = dto.NomeFile;
        imgModel.imgTitle = `Dettaglio ${index + 1}`;
        return imgModel;
      });

    this.loadingSezioneDettagli = false;

    setTimeout(() => {
      schedaJs.initFlexSlider_SezioneDettagli();
    }, 10);
    
    //Immagine piano taglie
    //
    let pianoTaglieImg = 
      this.schedaAppData.prodottoInfo.ListaImmagini.filter(dto => dto.TipoImmagineEnum == commonJs.tipoImmagineEnum.PianoTaglie);

    if(pianoTaglieImg.length) {
      let itemDto = pianoTaglieImg[0];
      let imgModel = new ImageDettaglioItem();
          imgModel.imgAltText = `Scheda tecnica di ${this.schedaAppData.prodottoInfo.Descrizione}`;
          imgModel.imgFileName = itemDto.NomeFile;
          imgModel.imgTitle = 'Scheda tecnica o piano taglie';
      webApiProxy.getGenericImagesFullFilePath(this.schedaAppData.basePathImmaginiDettaglio, imgModel.imgFileName).then(res => {
          imgModel.imgSrcRelativePath = res.data;
          this.imgPianoTaglie = imgModel;
        });
    } 
    else {
      this.imgPianoTaglie = null;
    }

    //Articoli alternativi
    //
    this.loadingSezioneArtAlternativi = true;
    this.artAlternativi = 
      this.schedaAppData.prodottoInfo.ListaArtAlternativi.map((articolo) => {
        let model = new ArtAlternativoItem();
        model.imgAltText = articolo.ImmagineFileName;
        model.imgTitle = articolo.CodName;
        model.urlScheda = articolo.Url; //this.schedaAppData.schedaBaseUrl + articolo.CodiceListino;
        model.imgFileName = articolo.ImmagineFileName;
        return model;
      });
    
    this.loadingSezioneArtAlternativi = false;

    setTimeout(() => {
      schedaJs.initFlexSlider_SezioneAlternativi();
      // this.artAlternativi.forEach((x) => 
      //   {
      //       webApiProxy.getGenericImagesFullFilePath(this.schedaAppData.basePathImmaginiArtAlternativi, x.imgFileName).then(relativePath => {
      //           x.imgSrcRelativePath = relativePath.data;
      //         });
      //   }); 
    }, 10);
    
    //Sezione Magazzini
    //
    let seDisabilitaControlloDisponibilita = 
      this.schedaAppData.prodottoInfo.SeCategoriaFullCustom || this.schedaAppData.prodottoInfo.DisabilitaControlloQta;

    webApiProxy.getSezioneMagazzini(this.schedaAppData.prodottoInfo.CodiceListino, seDisabilitaControlloDisponibilita)
      .then(res => {
        this.loadingIconeColore = true;
        this.datiMagazzini = res.data; //.filter(x => x.totaleStock > 0 || x.seArriviPrevisti);
        
        this.updateMagazzinoSelezionato(this.datiMagazzini.length > 0 ? this.datiMagazzini[0] : null, this.datiMagazzini);
    
        this.loadingSezioneMagazzini = false;
        this.loadingIconeColore = false;
      })
      .then(() => {
        $(".popoverInfoMagazzino").popover({
          container: 'body',
          trigger: 'hover',
        }); 
      });
  },
  async mounted() {
    //Controllo se mostrare modale GM Prime
    //      
    this.loadPrimeContent = false;
    if(this.userInfo){
      let servizi = await webApiProxy.getServizi(this.userInfo.IdAzienda, commonJs.COD_TIPO_SERVIZIO_PRIME, '');
      let carrello = await webApiProxy.getCarrelloByIdAzienda(this.userInfo.IdAzienda);

      let servizioPrimeGiaInCarrello = carrello.data.some(x => x.SeArtServizio && servizi.data.some(y => y.Codice == x.CodiceArticolo));

      if(!servizioPrimeGiaInCarrello){
        let cookieGMPrime = Cookies.get(commonJs.messaggioAbbonatiGmPrimeRcordaSceltaCookieKey);
        if(cookieGMPrime === undefined || cookieGMPrime === ''){
          if(commonJs.seMostrareMessaggioPromozionaleTipoServizio(commonJs.COD_TIPO_SERVIZIO_PRIME)){
            this.loadPrimeContent = true;
            this.$store.dispatch('setMessagePrimeAlreadyShown', true);
            this.$vfm.show('gmPrimeModal');
          }
        }
      }
    }
  },
};
</script>

<style scoped>

  .withNoPaddingLeft{
    padding-left:0px;
  }

  /*Serve per allineare verticalmente due col all'interno di una row. Questo per Bootstrap v. < 4*/
  .vcenter {
    display: inline-block;
    vertical-align: middle;
    float: none;
  }

  .pointer{
    cursor: pointer;
  }

  .linkGenerico{
    cursor:pointer;
    font-weight: normal;
    text-decoration: underline;
    color:red;
  }

  .link-breadcrumbs{
    color:black !important;
  }

  .linkDisponibilitaArticolo {
    font-weight: normal;
    text-decoration: underline;
    cursor:pointer;
  }

  .linkDisponibilitaArriviPrevistiClass{
    color:#028bff;
    /* font-weight: bold; */
  }

  .link-no-txt-decoration,
  .link-no-txt-decoration:hover,
  .link-no-txt-decoration:visited {
    text-decoration:none !important;
    color:initial;
  }

  .lblPrezzoBaseClass{
    font-size: larger;
    font-weight: bold;
    color: red;
    margin-left: 20px;
  }

  .lblPrezzoStrikeout{
    text-decoration: line-through;
    color: darkgray;
  }

  .lblPrezzoUnderlinePointer{
    text-decoration: underline;
    cursor: pointer;  
  }

  .hypInfoLoggatiEScopriClass a{
    color:red;
    font-weight: bold;
    text-decoration: underline;
    cursor: pointer;
  }

  .lblPrezzoOriginaleClass{
    font-size:larger;
    font-weight: bold;
    color:darkgray;
    text-decoration: line-through;
  }

  .loader-centered{
    text-align: center;
  }

  /* #carouselGalleriaFotografica ul.slides li{
    height: 120px !important;
  } */

  /*YT style*/
  /*Pulsante play su thumbnails*/
  /*inizio*/
  .playButtonContainer {
    margin-top: -50px;
    margin-left: 20px;
    margin-right: 20px;
    text-align: center;
    background-color: grey;
    transition: 0.3s;
    opacity: 0.7;
    border-radius: 5px;
    position: relative;
    height: 30px;
    width: 40px;
    padding: 4px;
    cursor: pointer;
  }

  .playButtonContainer:hover{
    background-color:red;
  }

  .playButton{
    position:relative;
    background-repeat:no-repeat;
    background-position:center;
    background-size:contain;
    height:20px;
  }

  div[aria-describedby=youtubePlayer] iframe{
    width: 640px !important;
    height:360px !important;
  }
  /*fine*/

  .ui-dialog .ui-dialog-content{
    padding:0px !important;
  } 
   
  .icon-color-container div.v-spinner{
    display:inline-block;
  }

  .preventivo-step{
    padding:7px;
    background-color:#EEEEEE;
  }
  .preventivo-step label{
    margin:0;
  }

  .nav-tabs{
    border-bottom:none;
  }
  ul.nav-tabs{
    margin-left: 0;
  }

  .tableDettagliProdotto,
  .tableDettagliImballo {
    width: 100%;
    color:initial;
  }

  .tableDettagliProdotto td,
  .tableDettagliImballo td{
    padding: 10px 5px; 
    border: 1px solid lightgray;
  }

  .tableDettagliProdotto tr td:first-child,
  .tableDettagliImballo tr td:first-child{
    white-space: nowrap;
    width: 164px; /*1px*/
    min-width: 164px; /*1px*/
  }

  .tableDettagliProdotto td:not(:first-child),
  .tableDettagliImballo td:not(:first-child){
    text-align: center;
  }

  #dettagli-prodotto,
  #dettagli-imballo{
    overflow-x: auto;
  }

  .nav-tabs > li{
    width: 165px;
  }

  .nav > li:not(.active) > a{
    background-color: #EEEEEE;
  } 

  .nav-tabs > li > a{
    margin-right: 0;
  }

  .nav-tabs > li.active > a, 
  .nav-tabs > li.active > a:hover, 
  .nav-tabs > li.active > a:focus {
    border-bottom-color: #ddd;
  }

  .tablePrezzi{
    margin-bottom: 5px;
  }

  .tablePrezzi td{
    border: 1px solid lightgray;
    padding: 5px;
    white-space:nowrap;
  }

  .tablePrezzi td:not(:first-child){
    text-align: center;
  }

  @keyframes yellowfade {
  from {
    background: yellow;
  }
  to {
    background: transparent;
  }
}

#flashMessage {
  animation-name: yellowfade;
  animation-duration: 3s;
  text-align: center;
  padding: 10px;
}

.descrizione-estesa{
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
  font-size:16.5px;
}

</style>
